module.exports = __webpack_public_path__ + "img/54c1f25b5461833b60ac86e87f3b56e0.png";